import { typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import { THEME_UI_DEFAULT_KEY } from './types.esm.js';

var toVarName = function toVarName(key) {
  return "--csg-tui-".concat(key.replace("-".concat(THEME_UI_DEFAULT_KEY), ''));
};
var toVarValue = function toVarValue(key) {
  return "var(".concat(toVarName(key), ")");
};
var join = function join() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.filter(Boolean).join('-');
};
var reservedKeys = {
  useCustomProperties: true,
  initialColorModeName: true,
  printColorModeName: true,
  initialColorMode: true,
  useLocalStorage: true
};

// convert theme values to custom properties
var toCustomProperties = function toCustomProperties(obj, parent, themeKey) {
  var next = Array.isArray(obj) ? [] : {};
  for (var key in obj) {
    var value = obj[key];
    var name = join(parent, key);
    if (value && _typeof(value) === 'object') {
      next[key] = toCustomProperties(value, name);
      continue;
    }
    if (reservedKeys[key]) {
      next[key] = value;
      continue;
    }
    next[key] = toVarValue(name);
  }
  return next;
};

export { toCustomProperties };
//# sourceMappingURL=custom-properties.esm.js.map
